import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-[#0a0a0a] py-10 md:py-16 px-4 border-t-4 border-gray-800" data-id="element-246">
      <div className="max-w-3xl mx-auto" data-id="element-247">
        <div className="bg-[#111] p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg text-center md:text-left" data-id="element-248">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-3" data-id="element-249">
            El sistema
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-6 leading-tight" data-id="element-250">
            Qué es Método Barber Pro
          </h2>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-6 mx-auto md:mx-0" data-id="element-251"></div>

          <div className="space-y-5" data-id="element-252">
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-253">
              Método Barber Pro es una formación online diseñada para aprender
              barbería con un sistema claro y profesional.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-254">
              Incluye clases en video, explicación técnica y un manual completo
              que refuerza cada etapa del aprendizaje.
            </p>
            <div className="bg-[#c41e3a]/10 border border-[#c41e3a]/30 p-4 rounded-lg mt-6 inline-block" data-id="element-255">
              <p className="text-lg md:text-xl text-white font-black" data-id="element-256">
                No es contenido aislado.{' '}
                <span className="text-[#c41e3a]" data-id="element-257">Es un método.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}